import { Col, Row } from 'antd';
import { observer } from 'mobx-react-lite';
import React, { useCallback, useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { PhasesProps } from '../../stores/PhasesStore';
import { RootStoresContext } from '../../stores/RootStore';
import { cleanString } from '../../util/renderHelpers';

type PhasesComponentProps = {
  children?: never;
  col?: { xs?: number; lg?: number };
};

const PhaseContent: React.FC<PhasesProps> = ({
  phaseDesc,
  phaseName,
  phasePath,
  phaseNumber,
  phaseColor,
  phaseIcon,
  phaseSub,
}) => {
  return (
    <Link className={`phase-link ${phaseColor}`} to={phasePath} title={cleanString(phaseName)}>
      <Row className="phase__wrapper" type={'flex'}>
        <Col
          className={`phase-icon${
            Array.isArray(phaseSub) && phaseSub.length > 0 ? ' has-sub' : ''
          }`}
        >
          <span className="phase-icon__wrapper" style={{ backgroundImage: `url(${phaseIcon})` }} />
        </Col>
        <Col className="phase-content">
          <h2 className="phase-title">{cleanString(phaseName)}</h2>
          <p className="phase-description">{cleanString(phaseDesc)}</p>
        </Col>
      </Row>
    </Link>
  );
};

const SubPhase: React.FC<PhasesProps> = props => {
  return (
    <div className="sub-phase">
      <PhaseContent {...props} />
    </div>
  );
};

const Phase: React.FC<PhasesProps> = props => {
  const subPhases = props.phaseSub as PhasesProps[];
  const phaseNum = Math.floor(Number(props.phaseNumber));
  const displaySubPhase =
    subPhases &&
    subPhases.map((subPhase, index) => (
      <SubPhase key={subPhase.phaseId} {...subPhase} phaseNumber={`${phaseNum}.${index + 1}`} />
    ));
  return (
    <div className="phase">
      <PhaseContent {...props} />
      {displaySubPhase}
    </div>
  );
};

const Phases: React.FC<PhasesComponentProps> = observer(({ col }) => {
  const rootStore = useContext(RootStoresContext);

  const fetchPhases = useCallback(() => {
    rootStore.phasesStore.getPhases(
      `${process.env.REACT_APP_API || ''}${process.env.REACT_APP_BASE_PATH || ''}${process.env
        .REACT_APP_PHASES_API || ''}`
    );
  }, [rootStore.phasesStore]);

  useEffect(() => {
    fetchPhases();
  }, [fetchPhases]);

  const displayPhases =
    rootStore.phasesStore.phases &&
    rootStore.phasesStore.phases.map((phase, index) => (
      <Phase key={phase.phaseId} phaseNumber={`${index + 1}.0`} {...phase} />
    ));
  return !rootStore.phasesStore.isPending && !rootStore.pageStore.isPending ? (
    <Col xs={{ span: col && col.xs }} lg={{ span: col && col.lg }}>
      <div className="phases">{displayPhases}</div>
    </Col>
  ) : null;
});

export default React.memo(Phases);
